import React from 'react';
import PropTypes from 'prop-types';
import MediaCentralImage from 'components/shared/MediaCentralImage';

class ResizedMediaCentralImage extends React.Component {
  static propTypes = {
    className: PropTypes.string.isRequired,
    cropHeight: PropTypes.number,
    cropWidth: PropTypes.number,
    image: PropTypes.object.isRequired,
    scaleHeight: PropTypes.number,
    scaleWidth: PropTypes.number,
  };

  /* Create props for media central image component
  that will scale an image close to the desired dimensions
  while while preserving aspect ratio, then crop it */
  buildCropProps() {
    const props = {};
    const actualRatio = this.props.image.height / this.props.image.width;
    let finalWidth = this.props.image.width;

    if (this.props.cropWidth * actualRatio > this.props.cropHeight) {
      props.scaleX = this.props.cropWidth;
      finalWidth = this.props.cropWidth;
    } else {
      props.scaleY = this.props.cropHeight;
      finalWidth = Math.floor(this.props.cropHeight * 1 / actualRatio);
    }

    const xCoor = Math.floor((finalWidth - this.props.cropWidth) / 2);
    props.crop = {
      x: xCoor,
      y: 0,
      width: this.props.cropWidth,
      height: this.props.cropHeight,
    };

    return props;
  }

  buildScaleProps() {
    const props = {};

    if (this.props.scaleWidth) {
      props.scaleX = this.props.scaleWidth;
    }

    if (this.props.scaleHeight) {
      props.scaleY = this.props.scaleHeight;
    }


    return props;
  }

  render() {
    // If both cropHeight and cropWidth are provided, crop the image, otherwise just scale it
    const imageProps = this.props.cropHeight && this.props.cropWidth
      ? this.buildCropProps() : this.buildScaleProps();
    return (
      <MediaCentralImage
        src={this.props.image.src}
        className={this.props.className}
        {...imageProps}
      />
    );
  }
}

export default ResizedMediaCentralImage;
